import React from 'react'
import Icon from '../../Icon2/Icon'
import Button from '../../Button/Button'
const BulkActionAlertBanner = ({ alertInfoBannerDetails }) => {
  // Add some message as fallback while checking on storybook like this ["Action Limit Reached", " The 'Unpublish' action limited to 10 and 'Publish' action limited to 10 entries. You can perform other bulk actions on up to 20 records."]
  const messageHasHeaderAndDetails = alertInfoBannerDetails?.message?.split(":").length == 2;
  const [heading, details] = messageHasHeaderAndDetails ? alertInfoBannerDetails?.message.split(":") : [null, alertInfoBannerDetails?.message];

  return (
    <div className={`bulk_action_alert_banner ${alertInfoBannerDetails.bannerType ? "info" : ""} flex-justify flex-v-center`} data-test-id="cs-table-info-banner">
      <div className="bulk_action_alert_banner-message font-size-large ml-20 lh-default" data-test-id="cs-table-info-banner-message">
        {heading ? <span className="font-semi-bold">{heading}:</span> : null}
        {details ? <span className="font-regular">{details}</span> : null}
      </div>
      <div className="flex-center flex-v-center banner_actions mr-20" data-test-id="cs-table-info-banner-actions">
        {alertInfoBannerDetails?.onDontShowAgain ? <span className="bulk_action_alert_banner-dont_show_again font-size-large font-semi-bold mr-10" onClick={alertInfoBannerDetails?.onDontShowAgain} >Don't show this again</span> : null}
        {alertInfoBannerDetails?.onAction ? <Button buttonType="tertiary" version='v2' className="bulk_action_alert_banner-action_button font-size-large font-semi-bold mr-10" onClick={alertInfoBannerDetails?.onAction} testId="cs-table-info-banner-action-text">{alertInfoBannerDetails?.actionText}</Button> : null}
        <span className='close-icon' onClick={alertInfoBannerDetails?.onDimnish} data-test-id="cs-table-info-banner-close-icon">
          <Icon version="v2" icon="CloseNoborder" size="medium" />
        </span>
      </div>
    </div>
  )
}

export default BulkActionAlertBanner